import { useState } from "react";
import axios from "axios";
import "./ForgotPassword.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendOtp, userResetPassword, userVerifyOtp } from "../redux/authSlice";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1); 
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "","",""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const [newPassword, setNewPassword] = useState("");   
const [resetToken, setResetToken] = useState("");
const dispatch = useDispatch();
  //  Send OTP
  const handleSendOtp = async () => {
    try {
      setLoading(true);
      setError("");
      dispatch(sendOtp({ email })).unwrap()
        .then(() => {
          setStep(2);
        })
        .catch((err) => {
          console.log('sendotperr:', err);
          
          setError(err?.error  || "Failed to send OTP");
        });
      // await axios.post("http://localhost:5000/api/auth/send-otp", { email });

      // setStep(2);
    } catch (err) {
      setError(err.response?.data?.error  || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  //  Verify OTP
  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      setError("");

      const otpValue = otp.join("");
      if (otpValue.length !== 6) {
      setError("Enter complete 6-digit OTP");
      setLoading(false);
      return;
    }

    console.log("Sending OTP:", otpValue); 
    dispatch(userVerifyOtp({ email, otp: otpValue })).unwrap()
      .then((res) => {
        console.log('tokenres:', res);
        
        setResetToken(res?.resetToken || resetToken);
        setStep(3);
      })
      .catch((err) => {
        setError(err?.error  || "Invalid OTP");
      });
    //
    //  const res =  await axios.post("http://localhost:5000/api/auth/verify-otp", {
    //     email,
    //     otp: otpValue,
    //   });
      //  setResetToken(res.data.resetToken); 
      // setStep(3);
    } catch (err) {
      setError(err.response?.data?.error  || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  //  Reset Password
  const handleResetPassword = async () => {
    try {
      setLoading(true);
      setError("");

      if (!newPassword) {
      setError("Please enter a new password");
      return;
    }
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    await dispatch(userResetPassword({ newPassword, resetToken })).unwrap();
      // await axios.post("http://localhost:5000/api/auth/reset-password", { newPassword },
      // {
      //   headers: {
      //     Authorization: `Bearer ${resetToken}`, 
      //   },
      // }
      // );

      setStep(4);
      setTimeout(() => {
  navigate("/login");
}, 2500);
    } catch (err) {
      setError(err.response?.data?.error  || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  // OTP input handler
  const handleOtpChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
  };

  return (
    <div className="fp">
      {/* LEFT HERO */}
      <div className="fp-hero">
        <div className="fp-hero-bg"></div>
        <div className="fp-hero-ov"></div>

        <div className="fp-hbody">
          <div className="fp-badge">
            <span className="fp-bdot"></span> {t("secureAccess")}
          </div>

          <h1 className="fp-h1">
            {t("heroTitle")}
          </h1>

          <p className="fp-sub">
            {t("heroSubtitle")}
          </p>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="fp-panel">
        <div className={`fp-card show`}>
          <div className="fp-ch">
            <h2>{t("forgotPassword")}</h2>
            <p>{t("followSteps")}</p>
          </div>

          {/* ERROR */}
          {error && <div className="fp-err">{error}</div>}

          {/* STEP 1 - EMAIL */}
          {step === 1 && (
            <div className="fp-flds">
              <div className="fp-field">
                <label>{t("email")}</label>
                <div className="fp-box">
                  <input
                    type="email"
                    placeholder={t("enterEmail")}
                    value={email}   
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <button className="fp-btn" onClick={handleSendOtp} disabled={loading}>
                {loading ? <span className="fp-spin"></span> : t("sendOtp")}
              </button>
            </div>
          )}

          {/* STEP 2 - OTP */}
          {step === 2 && (
            <>
              <div className="fp-otp-row">
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    className="fp-otp-cell"
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, i)}
                  />
                ))}
              </div>

              <button className="fp-btn" onClick={handleVerifyOtp} disabled={loading}>
                {loading ? <span className="fp-spin"></span> : t("verifyOtp")}
              </button>
            </>
          )}

          {/* STEP 3 - RESET PASSWORD */}
          {step === 3 && (
            <div className="fp-flds">
              <div className="fp-field">
                <label>{t("newPassword")}</label>
                <div className="fp-box">
                  <input
                    type="password"
                    placeholder={t("enterNewPassword")}
                    value={newPassword}           
                    onChange={(e) => setNewPassword(e.target.value)} 
                  />
                </div>
              </div>

              <button className="fp-btn" onClick={handleResetPassword} disabled={loading}>
                {loading ? <span className="fp-spin"></span> : t("newPassword")}
              </button>
            </div>
          )}

          {/* STEP 4 - SUCCESS */}
          {step === 4 && (
            <div className="fp-done">
              <div className="fp-done-ring">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <polyline
                  points="4,13 9,18 20,7"
                  stroke="url(#gold-grad)"
                  strokeWidth="4.1"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
                <defs>
                  <linearGradient id="gold-grad" x1="4" y1="7" x2="20" y2="18" gradientUnits="userSpaceOnUse">
                    <stop offset="100%" stopColor="rgb(48, 150, 62)" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
              <h3>{t("passwordResetSuccess")}</h3>
              <p>{t("canLoginWithNewPassword")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;